import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

import logo from './images/kitchen-kart-logo.png'
import homeBanner from './images/home-banner-img.png'
import Section2Img from './images/healthy-tasty-food-section-img.png'
import phoneIcon from './images/phoneIcon.png'
import MenuItem1 from './images/MenuItem1.jpg'
import MenuItem2 from './images/MenuItem2.jpg'
import MenuItem3 from './images/MenuItem3.jpg'
import MenuItem4 from './images/MenuItem4.jpg'
import MenuItem5 from './images/MenuItem5.jpg'
import TiffinImage1 from './images/TiffinImage1.jpeg'
import TiffinImage2 from './images/TiffinImage2.jpeg'
import TiffinImage3 from './images/TiffinImage3.jpeg'
import TiffinImage4 from './images/TiffinImage4.jpeg'
import Logo2 from './images/kitchen-kart-logo 2.png'
import OwlCarousel from './OwlCarousel'

import './App.css'
import { useEffect } from 'react'

function App() {
  const images = [MenuItem1, MenuItem2, MenuItem3, MenuItem4, MenuItem5, TiffinImage2, TiffinImage3]
  
  const scrollTo = (id) => {
    document.getElementById(id).scrollIntoView();
  }

  return (
  <>
  {/* navbar */}
  <nav class="navbar navbar-expand-lg navbar-light bg-light py-3">
    <div class="container-fluid">
      {/* <img src={logo}/> */}

      <span style={{color:"#3E734D", letterSpacing: ".02px"}} className="display-6 fw-bold">Tiffin Kart</span>

      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end" id="navbarNavAltMarkup">
        <div class="navbar-nav">
          <span onClick={()=> scrollTo("menu")} class="link fs-2 mx-3" href="#">Menu</span>
          <span onClick={()=> scrollTo("aboutus")} class="link fs-2 mx-3" href="#">About Us</span>
          <span onClick={()=> scrollTo("contactus")} class="link fs-2 mx-3" href="#">Contact</span>
        </div>
      </div>
    </div>
  </nav>

    
    {/* 1st section */}
    <section class="py-3 container-fluid">
      <div className="row">
        <div class="col-6 d-block d-sm-none d-md-none d-flex justify-content-center" style={{width: "100%"}}>
            <img style={{width: "80%"}} src={homeBanner}/>
        </div>
        <div class="col-sm-6 d-flex flex-column justify-content-center align-items-center text-center section1-heading">
            <span className='display-2 fw-bold px-2' style={{color: "#3E734D"}}>
              Delicious <span style={{color: "#D69B29"}}>home cooked</span> food in town
            </span>
            <button className='text-white fw-medium rounded-pill border-0 px-3 py-2 d-flex align-items-center get-in-touch-btn' style={{backgroundColor: "#D69B29"}}><img style={{width: "2rem", marginRight: ".5rem"}} src={phoneIcon}/><a className="fs-4" style={{textDecoration: "none", color: "white"}} href="tel:+917056322071">Get in touch</a></button>
        </div> 
        <div class="col-sm-6 d-none d-sm-block text-center">
            <img style={{width: "70%"}} src={homeBanner}/>
        </div> 
      </div>
    </section>

    <section style={{backgroundColor: "#E7E7E7", width: "100%"}} className="pt-5 container-fluid" id="aboutus">
      <div className='healthy-section-heading fs-2 fw-bold text-center mb-3'>HEALTHY & DELICIOUS FOOD AT AFFORDABLE PRICES</div>
      <b><hr className="mb-2 mx-auto" style={{color: "#D69B29", width: "80%"}}/></b>

      <div className='row pb-5 pb-md-2'>
          <div style={{paddingLeft: "7rem"}} className='col-lg-5 text-center my-auto section2-image-container'>
            <img className="section2-image" src={Section2Img}/>
          </div>
          <div style={{paddingLeft: "2rem"}} className='col-lg-7 my-auto healthy-section-list'>
            <p className="section-2-para">Tiffin Kart aims to serve food that is not just delicious, but also distinctive in providing healthy, homely experience. Our food is prepared in a sterile environment, with nothing but organically produced, fresh vegetables that are grown in-house.</p>
            <p className="delivery-details">Area of delivery - near bus stand , sector 7, sector 14, sector 15, near iffco chowk, udhyog vihar.</p>
              
              {/* <ol>
                <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                <li>Fusce efficitur nisi vel quam convallis euismod.</li>
                <li>Sed sollicitudin ipsum ac metus iaculis gravida.</li>
                <li>Donec posuere orci in lectus vehicula auctor.</li>
                <li>Nam sed purus molestie, tincidunt nunc sit amet, semper ante.</li>
              </ol> */}
          </div>
      </div>
    </section>

    <section id="menu" className="container-fluid my-5">
      <div className='fs-2 fw-bold text-center' style={{color: "#D69B29"}}>Menu <span style={{color: "#3E734D"}}>&</span> Gallery</div>
      <b><hr className="mb-2 mx-auto" style={{color: "#D69B29", width: "60%"}}/></b>
      
      <OwlCarousel images={images}/>
    </section>
    
    {/* footer */}
    <section id="contactus" style={{backgroundColor: "#E7E7E7", width: "100%"}} className='row py-5 d-flex justify-content-center footer-container container-fluid'>
      
      <div className='col-lg-4 d-flex flex-column contactus-heading'>
        {/* <img style={{width: "15rem"}} src={Logo2}/> */}
        <span style={{color:"#3E734D", letterSpacing: ".02px"}} className="display-6 fw-bold">Tiffin Kart</span>        <span className='fs-2 fw-bold mt-4 footer-heading'>Contact Us At</span>
        <span className='fs-4 fw-bold footer-content'>+91 7056322071</span>

        <span className='fs-2 fw-bold footer-heading'>Write Us At</span>
        <span className='fs-4 fw-bold footer-content'>droidyogi25@gmail.com</span>

      </div>

      <div className='col-lg-4 d-flex flex-column'>
        <span className='fs-2 fw-bold footer-heading'>Address</span>
        <span className='fs-4 fw-bold footer-content mb-2'>852/2 Acharya Puri, near bus stand Grugram, Haryana</span>
        
        {/* map */}
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14029.22049368601!2d77.01660876810315!3d28.470356297443836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d198da06a7095%3A0x56c207b392914ec6!2stiffin%20service%20near%20by%20me!5e0!3m2!1sen!2sin!4v1650698099130!5m2!1sen!2sin" width="100%" height="auto" style={{border: '0px'}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>

      <div className='col-lg-4 d-flex flex-column'>
        <span className='fs-2 fw-bold footer-heading working-hours-header'>Working Hours</span>
        <span className='fw-bold footer-content working-hours-content'>Mon: 7:00 AM - 5:00 PM</span>
        <span className='fw-bold footer-content working-hours-content'>Tue: 7:00 AM - 5:00 PM</span>
        <span className='fw-bold footer-content working-hours-content'>Wed: 7:00 AM - 5:00 PM</span>
        <span className='fw-bold footer-content working-hours-content'>Thu: 7:00 AM - 5:00 PM</span>
        <span className='fw-bold footer-content working-hours-content'>Fri: 7:00 AM - 5:00 PM</span>
        <span className='fw-bold footer-content working-hours-content'>Sat: 7:00 AM - 5:00 PM</span>
        <span className='fw-bold footer-content working-hours-content'>Sun: 7:00 AM - 5:00 PM</span>
      </div>

    </section>
  </>
    
  );
}

export default App;
